import React, {Component, PropTypes} from 'react';
import {Link} from 'react-router';
import TreeView from 'react-treeview';
import {toggleClass} from '../utils/domUtils';
import {naviTreeCollapse} from '../actions';
import {mileStone} from '../../.temp/asset';
import translate from '../../i18n/translate';

class NaviTreeView extends Component {
    constructor(props) {
        super(props);
    }

    createChild(entry, parentPath, index, currentDemoId, flag) {
        let currPath;
        let label;
        let contentUpdated;
        let collapsedIconClassName;
        let expandedIconClassName;
        let key;
        let level;
        let collapsedClassName = "tree-arrow ";
        flag = flag || '0';
        const {treeCollapsedKeeping, strings} = this.props;
        const demoIntl = strings.demo_intl;
        if (entry.hasOwnProperty('children')) {
            currPath = (parentPath || '') + (entry.path || '');
            level = flag + '_' + index;
            key = 'level' + level;
            if (!treeCollapsedKeeping.hasOwnProperty(key)) {
                treeCollapsedKeeping[key] = true;
            }
            var baseClassName = entry.title.replace(/ /g, '-').toLowerCase();
            if (!(baseClassName === 'feature-samples' || baseClassName === 'home' || baseClassName === 'demo-gallery' || baseClassName === 'quick-start')) {
                baseClassName = 'theme';
            }
            var textIndent = "";
            if(entry.level === 0) {
                textIndent = "gc-tree-level0";
            } else if(entry.level === 1) {
                textIndent = "gc-tree-level1";
            }

            collapsedIconClassName = 'gc ' + 'gc-' + baseClassName + '-collapsed';
            expandedIconClassName = 'gc ' + 'gc-' + baseClassName + '-expanded';

            contentUpdated = (Array.prototype.find.call(entry.children, function (item) {
                return item.hasOwnProperty(mileStone)
            }) !== undefined);

            collapsedClassName += treeCollapsedKeeping[key] ? collapsedIconClassName : expandedIconClassName;
            if (contentUpdated) {
                collapsedClassName += ' is_updated';
            }
            if (entry.path) {
                label = <Link onClick={this.props.onClick.bind(null,key)} to={`${currPath}`}>
                    <div>
                        <div className={collapsedClassName}></div>
                        {strings[entry.title] || entry.title}</div>
                </Link>;
            } else {
                label = <div onClick={this.props.onClick.bind(null,key)}>
                    <div className={textIndent}>
                        <div className={collapsedClassName}></div>
                        <span>{demoIntl[entry.id].title || entry.title}</span></div>
                </div>
            }
            return (
                <TreeView collapsed={this.props.treeCollapsedKeeping[key]}
                          key={key}
                          className={'view_arrow'}
                          nodeLabel={label}>
                    {entry.children.map((child, i) => this.createChild(child, currPath, i, currentDemoId, level))}
                </TreeView>
            );
        } else {
            let cssName = "empty-arrow-align";
            if (entry.level === 1) {
                cssName += ' level1';
            }
            currPath = parentPath + entry.id;
            key = 'child' + index;
            if (currentDemoId) {
                // if ((entry.title.replace(/\s/g, '').toLowerCase() === currentDemoId.replace(/\s/g, '').toLowerCase())
                //     || (entry.title.replace(/\s/g, '').toLowerCase().indexOf(currentDemoId.replace(/\s/g, '').toLowerCase()) >= 0)
                //     || (entry.title === currentDemoId)) {
                //     cssName += ' active';
                // }
                if(entry.id === currentDemoId) {
                    cssName += ' active';
                }
            }

            if (entry.hasOwnProperty(mileStone)) {
                var symbol = entry[mileStone];
                if(symbol === 'updated') {
                    cssName += ' is_updated';
                } else if(symbol === 'new') {
                    cssName += ' is_newed';
                } else {
                    cssName += ' is_sp1';
                }
            }
            return <div key={key} className={cssName}>
                <Link onClick={()=>{this.props.treeViewItemClick()}} to={`${currPath}`}>{demoIntl[entry.id] && demoIntl[entry.id].title || entry.title}</Link>
            </div>;
        }
    }

    render() {
        let currentDemoId;
        var href = window.location.href;
        var index = href.toLowerCase().indexOf('demos/');
        if (index > 0) {
            currentDemoId = href.slice(index + ('demos/'.length));
        }
        index = href.toLowerCase().indexOf('examples/');
        if (index > 0) {
            currentDemoId = href.slice(index + ('examples/'.length));
        }
        return (
            <div className="tree-view-wrapper">
                {this.props.dataSource.map((node, index) => {
                    return this.createChild(node, null, index, currentDemoId)
                })}
            </div>
        );
    }
}

NaviTreeView.propTypes = {
    dataSource: React.PropTypes.array.isRequired,
    naviTreeCollapsed: React.PropTypes.bool,
};

NaviTreeView.defaultProps = {
    strings: {}
};

export default translate('NaviTree')(NaviTreeView)



// WEBPACK FOOTER //
// ./client/components/NaviTreeView.js